import React from "react"
import {
    useDispatch,
    useSelector
} from 'react-redux'
import { selectClientsById } from '../users/usersSlice';
import { calcAge } from "./parQSlice";
import DatePicker from "react-datepicker"


function ClientInfo({ question, clientId, debouncedUpdateDB }) {
    const isTrainer = useSelector(state => state.users.current_user.account_type === "trainer");
    const currentUser = useSelector(state => state.users.current_user);
    const client = useSelector(state => selectClientsById(state, clientId))
    let dispatch = useDispatch();


    return (
        <div className="w-50 mb-2 mx-auto">
            {question.question}

            {question.answer_array.map(answerItem => {
                let answerType;

                if (answerItem.answer_type === "Numeric") {
                    answerType = "number"
                } else if (answerItem.answer_type === "Textfield") {
                    answerType = "text"
                } else {
                    answerType = answerItem.answer_type
                }

                let question_type = ["birthdate", "phone", "height", "height_units"
                    , "weight", "weight_units"].includes(answerItem.answer_values?.answer_id)
                    ? answerItem.answer_values?.answer_id : "standard"

                return (
                    <>
                        {["Textfield", "Numeric", "Date"].includes(answerItem.answer_type) &&
                            <div key={answerItem.answer_values?.answer_id}>
                                {/*console.log(answerItem, "ANSWER")*/}
                                <input key={answerItem.answer_field_id} type={answerType}
                                    className="form-control form-control-sm"
                                    placeholder={answerItem.placeholder_text}
                                    defaultValue={answerItem.answer_values?.answer}
                                    onBlur={(e) => {
                                        let answer_id = answerItem.answer_values?.answer_id
                                        if (answer_id === "birthdate") {
                                            let answer = e.target.value.replace(/-/g, '\/');
                                            let question_id = question.question_id;
                                            let category = "clientInfo";
                                            let payload = { answer, category, answer_id, question_id };
                                            dispatch(calcAge(payload))
                                        }
                                    }}
                                    onChange={(e) => {
                                        let answer = e.target.value;
                                        let answer_field_id = answerItem.answer_field_id
                                        let client_id = clientId;
                                        let answer_id = answerItem.answer_values?.answer_id
                                        let integer_answer = answerItem.answer_values?.integer_answer
                                        let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                        debouncedUpdateDB(payload)

                                    }}
                                />
                            </div>
                        }
                        {
                            ["lbs=0,kg=1", "in=0,cm=1"].includes(answerItem.answer_type) &&
                            //console.log(answerItem,"item") &&
                            <select key={answerItem?.answer_values?.answer_id} className=" selectOption ml-1"
                               
                                defaultValue={answerItem?.answer_values?.answer}
                                onChange={(e) => {
                                    let answer = e.target.value;
                                    //let category = question.category_name;       
                                    let answer_field_id = answerItem.answer_field_id
                                    let client_id = clientId;
                                    let answer_id = answerItem.answer_values?.answer_id
                                    let integer_answer = answerItem.answer_values?.integer_answer
                                    //let questionNumber = question.question_id;
                                    let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                    debouncedUpdateDB(payload)

                                }}
                            >
                                <option value="0" >
                                    {(answerItem.answer_values?.answer_id === "weight_units") && "lbs"}
                                    {(answerItem.answer_values?.answer_id === "height_units") && "inch"}
                                </option>
                                <option value="1">
                                    {(answerItem.answer_values?.answer_id === "weight_units") && "kg"}
                                    {(answerItem.answer_values?.answer_id === "height_units") && "cm"}
                                </option>
                            </select>
                        }

                        {
                            answerItem.answer_type === "Hardcoded" &&
                            <span key={answerItem.answer_values?.answer_id} className="ml-2">
                                {answerItem.answer_values?.answer_id === "age" ? <small> <i>{answerItem.answer_values?.answer}  years old </i></small> :
                                    <b>{answerItem.answer_values?.answer} </b>}
                            </span>

                        }
                    </>
                )
            })}
        </div >

    )
}

export default ClientInfo;